
import Vue, { PropType } from 'vue';

import Table from '@/components/common/Table.vue';
import { Subscription, Subscriber } from '@/interfaces/notifications';

interface Row {
	id: number;
	name: string;
	type: string;
	address: string;
}

export default Vue.extend({
	name: 'SiteLuminaireList',
	components: {
		Table,
	},
	data() {
		return {
			fields: [
				{ key: 'name', label: this.$t('Name'), sortable: true },
				{ key: 'type', label: this.$t('Method') },
				{ key: 'address', label: this.$t('Address') },
				{ key: 'editDelete', label: '' },
			],
		};
	},
	props: {
		subscription: { type: Object as PropType<Subscription> },
		subscribers: {
			type: Array as PropType<Subscriber[]>,
			default: (): Subscriber[] => [],
		},
		userPermission: { type: Boolean, default: true },
	},
	computed: {
		rows(): Row[] {
			const translations = new Map([
				['email', this.$t('E-mail').toString()],
				['sms', this.$t('SMS').toString()],
			]);
			return this.subscribers.map((s) => {
				return {
					id: s.id,
					name: s.name,
					type: translations.get(s.type)!,
					address: s.address,
				};
			});
		},
	},
	methods: {
		onAddNew() {
			this.$emit('addSubscriber');
		},
		onEdit(row: Row) {
			this.$emit(
				'modifySubscriber',
				this.subscribers.find((s) => s.id === row.id)
			);
		},
		onDelete(row: Row) {
			this.$emit(
				'removeSubscriber',
				this.subscribers.find((s) => s.id === row.id)
			);
		},
	},
});
